import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { JourneyDashboard } from './journey-dashboard';
import { JourneyStore } from './journey.store';
import { PublicJourneyConfig, PublicJourneyUseCases } from './public-journey.dependencies';

/**
 * Reads the draft kept on the phone, once. Whoever needs it first — the journey as it opens, or a
 * guard deciding whether an address can be shown — starts it; everyone else waits for the same.
 */
@Injectable()
export class JourneyStart {
  private readonly store = inject(JourneyStore);
  private readonly dashboard = inject(JourneyDashboard);
  private readonly useCases = inject(PublicJourneyUseCases);
  private readonly config = inject(PublicJourneyConfig);
  private readonly i18n = inject(TranslocoService);

  private started: Promise<void> | null = null;

  start(): Promise<void> {
    this.started ??= this.load();
    return this.started;
  }

  private async load(): Promise<void> {
    try {
      const draft = await this.useCases.loadDraft.execute({ draftId: this.config.draftId });
      this.store.draft.set(draft);
      if (draft !== null) {
        this.store.profile.set(draft.testament.owner);
        this.store.resumeAvailable.set(true);
      }
      await this.dashboard.refresh();
    } catch (error: unknown) {
      this.store.fail(error, this.i18n.translate('errors.unexpected'));
    } finally {
      this.store.initializing.set(false);
    }
  }
}
